//
// Module for the Employer Reporting Member Discrepancies Index view
//
rs.module("employer/reporting/memberdiscrepancies/index",

    ["controls/data/grid", "controls/components/event-banner"],

    function (gridModule, eventBanner) {

        // Initialize the module
        function initialize(summaryGridLrsApi, jsSelectors, backendUrls, codeValues, employerfundBalancingMethodCodeValue) {

            $.js(jsSelectors.filter).js(jsSelectors.filterSelect).change(updateSummaryGrid);
            $.js(jsSelectors.filter).js(jsSelectors.outstandingOnlyCheckBox).change(updateSummaryGrid);

            // Make backend call to update the summary grid
            function updateSummaryGrid() {

                // Regardless of balancing method, the filter includes the outstandingOnly option
                var filterValue = {
                    outstandingOnly: $.js(jsSelectors.filter).js(jsSelectors.outstandingOnlyCheckBox).is(":checked")
                };

                // Filter by batch number or fiscal year
                if (employerfundBalancingMethodCodeValue == codeValues.balancingMethodBatch) {
                    filterValue.batchNumber = $.js(jsSelectors.filter).js(jsSelectors.filterSelect).val();
                }
                else if (employerfundBalancingMethodCodeValue == codeValues.balancingMethodFiscalYear) {
                    filterValue.fiscalYear = $.js(jsSelectors.filter).js(jsSelectors.filterSelect).val();
                }

                $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).show();

                // Remove event banner messages
                eventBanner.removeAllMessages();

                // Update summary grid data
                gridModule.update(
                    backendUrls.getMemberDiscrepanciesSummaryGrid,
                    filterValue,
                    summaryGridLrsApi.agGridApi,
                    function () { $.js(jsSelectors.filter).js(jsSelectors.loadingSpinner).hide() }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);